export default __webpack_public_path__ + "static/media/2420_2424 side.e334766b.jpg";